/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import HeaderFormComponent from 'components/FormHeader.vue';
import G3wFormFooter       from 'components/FormFooter.vue';

const __vue_script__ = {

  /** @since 3.8.6 */
  name: 'g3w-form',

  data() {
    return {
      state: {},
      switchcomponent: false,
      body: {
        components: {
          before: [],
          after: []
        }
      }
    }
  },
  components: {
    g3wformheader: HeaderFormComponent,
    G3wFormFooter
  },
  transitions: { 'addremovetransition': 'showhide' },
  methods: {
    isRootComponent(component) {
      return this.$options.service.isRootComponent(component);
    },
    backToRoot() {
      this.$options.service.setRootComponent();
    },
    handleRelation(relationId) {
      this.$options.service.handleRelation(relationId);
    },
     disableComponent({ id, disabled = false }) {
       this.$options.service.disableComponent({
         id,
         disabled
       });
     },
    resizeForm(perc) {
      this.$options.service.setCurrentFormPercentage(perc)
    },
    switchComponent(id) {
      this.switchcomponent = true;
      this.$options.service.setCurrentComponentById(id);
    },
    changeInput(input) {
      return this.$options.service.changeInput(input);
    },
    addToValidate(input) {
      this.$options.service.addToValidate(input);
    },
    removeToValidate(input) {
      this.$options.service.removeToValidate(input);
    },
  },
  async updated() {
    await this.$nextTick();
    if (this.switchcomponent) { setTimeout(() => this.switchcomponent = false, 0) }
  },
  created() {
    this.$options.service.getEventBus().$on('set-main-component', () => {
      this.switchComponent(0);
    });
    this.$options.service.getEventBus().$on('component-validation', ({id, valid}) => {
      this.$options.service.setValidComponent({ id, valid });
    });
    this.$options.service.getEventBus().$on('addtovalidate', this.addToValidate);
    this.$options.service.getEventBus().$on('disable-component', this.disableComponent);
  },
  mounted() {
    // check if is valid form (it used by footer component)
    this.$options.service.isValid();
    this.$options.service.setReady(true);
  },
  beforeDestroy() {
    this.$options.service.clearAll();
  }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"g3wform_content",staticStyle:{"position":"relative"}},[_c('bar-loader',{attrs:{"loading":_vm.state.loading}}),_vm._v(" "),_c('g3wformheader',{ref:"g3wformheader",attrs:{"currentid":_vm.state.currentheaderid,"headers":_vm.state.headers,"update":_vm.state.update,"valid":_vm.state.valid},on:{"resize-form":_vm.resizeForm,"clickheader":_vm.switchComponent}}),_vm._v(" "),_c('div',{ref:"g3wform_body",staticClass:"g3wform_body"},[_vm._l((_vm.body.components.before),function(component){return _c(component,{tag:"component",attrs:{"fields":_vm.state.fields}})}),_vm._v(" "),_c('keep-alive',[_c(_vm.state.component,{tag:"component",attrs:{"handleRelation":_vm.handleRelation,"state":_vm.state},on:{"addtovalidate":_vm.addToValidate,"removetovalidate":_vm.removeToValidate,"changeinput":_vm.changeInput}})],1),_vm._v(" "),_vm._l((_vm.body.components.after),function(component){return _c(component,{tag:"component",attrs:{"fields":_vm.state.fields}})})],2),_vm._v(" "),_c('g3w-form-footer',{ref:"g3w_form_footer",attrs:{"isRootComponent":_vm.isRootComponent,"backToRoot":_vm.backToRoot,"state":_vm.state}})],1)}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "Form.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__